import React from 'react';
import useSWR from 'swr';

import { PlayerState } from '../types/state';
import { GameContext } from '../contexts/game';
import { getPlayerState } from '../services/players';

const fetchPlayerStates = async (gameCode: string, players: PlayerState[]) => {
  return Promise.all(
    players.map((player) => getPlayerState(gameCode, player.code!))
  );
};

export const useGetPlayerStateByTeamCode = (
  gameCode?: string,
  teamCode?: string
) => {
  const [game] = React.useContext(GameContext);

  const players = React.useMemo(() => {
    if (!game.gameState) return [];
    if (teamCode === 'All Teams' || !teamCode) return game.gameState.players;

    return game.gameState.players.filter(
      (player) => player.teamCode === teamCode
    );
  }, [game.gameState, teamCode]);

  const shouldFetch = !!gameCode && !!players.length;

  const { data, error, isLoading, mutate } = useSWR(
    shouldFetch ? ['player-states', gameCode, teamCode] : null,
    () => fetchPlayerStates(gameCode!, players)
  );

  return {
    playerStates: data,
    isLoading,
    isError: error,
    mutate
  };
};
